import React from 'react';
import PropTypes from 'prop-types';

import DataCard from '../../../common/card/DataCard';

export const Processing = ({ data }) => {
  const { weightLogs = [], isProcessedAtHub, orderType, customerPreferences, notes } = data;

  const LABEL_BY_STATUS = {
    DESIGNATED_FOR_PROCESSING_AT_HUB: 'Sales Weight: ',
    READY_FOR_PROCESSING: 'Sales Weight: ',
    HUB_PROCESSING_ORDER: 'Pre-Processing Weight: ',
    PROCESSING: 'Pre-Processing Weight: ',
    HUB_PROCESSING_COMPLETE: 'Post-Processing Weight: ',
    COMPLETED: 'Pickup Weight: ',
    READY_FOR_PICKUP: isProcessedAtHub
      ? 'Receive Back at Store Weight: '
      : 'Post-Processing Weight: ',
    ...(orderType === 'RESIDENTIAL' && { RECEIVED_AT_HUB_FOR_PROCESSING: 'Sales Weight: ' }),
  };

  const weights = weightLogs.length
    ? weightLogs.map(({ status, totalWeight }) => `${LABEL_BY_STATUS[status]} ${totalWeight} \n`)
    : 'No weights logged';

  const details = [
    { label: 'Weight Review', data: weights },
    {
      label: 'Customer Notes',
      data: customerPreferences?.notes || 'No customer preferences added',
    },
    { label: 'Custom Order Notes', data: notes || 'Notes are not added for this order' },
  ];

  return <DataCard title="Processing" cardData={details} />;
};

Processing.propTypes = {
  data: PropTypes.shape({
    weightLogs: PropTypes.arrayOf(
      PropTypes.shape({ status: PropTypes.string, totalWeight: PropTypes.number }),
    ),
    isProcessedAtHub: PropTypes.bool,
    orderType: PropTypes.string,
    customerPreferences: PropTypes.shape({ notes: PropTypes.string }),
    notes: PropTypes.string,
  }).isRequired,
};
